import { Box, Grid, Typography } from '@mui/material'
import { Table, TableColumnsType, Tag } from 'antd'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import {
  EOrderStatus,
  IOrder,
  IOrderItem,
  OrderShippingProvider,
} from '../../../types/order'
import PageUrls from '../../../constants/page-urls'
import TrackingProviderImage from '../../../components/TrackingProviderImage'
import OrderTag from '../../../components/OrderTag'
import { ONLY_DATE_TIME_FORMAT } from '../../../constants/global'
import { IFacebookChatRoom } from '../../../types/facebook'
import useAxios from '../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../types/pagination'
import CircularLoading from '../../../components/CircularProgress'

interface Props {
  chatRoom?: IFacebookChatRoom | null
}

const OrderHistoryTable = (props: Props) => {
  const { chatRoom } = props

  const ordersList = useAxios<PaginationResponseInterface<IOrder>>({
    method: 'GET',
    url: '/order',
    params: {
      page: 1,
      perPage: 10,
      refId: chatRoom?.objectId,
    },
  })

  const columns: TableColumnsType<IOrder & { key: number }> = [
    // {
    //   title: 'ลำดับ',
    //   dataIndex: 'key',
    //   key: 'key',
    //   width: 80,
    //   align: 'center' as const,
    //   render: (key: number) => {
    //     return (
    //       <Typography
    //         variant="subtitle1"
    //         color="text.secondary"
    //         textAlign={'center'}
    //       >
    //         {key + 1}
    //       </Typography>
    //     )
    //   },
    // },
    {
      title: 'เลขออเดอร์',
      dataIndex: 'code',
      key: 'code',
      align: 'center' as const,
      render: (code: string, order: IOrder) => (
        <>
          <Typography
            variant="subtitle1"
            color="text.primary"
            component={Link}
            target='_blank'
            to={`${PageUrls.Orders.Detail}/${order.objectId}`}
            sx={{ cursor: 'pointer' }}
          >
            {code}
          </Typography>
          {order.trackingCode && order.trackingProvider && (
            <Box mb={1}>
              <TrackingProviderImage
                trackingProvider={
                  order.trackingProvider as OrderShippingProvider
                }
              />
              <Typography
                variant="subtitle2"
                color="text.secondary"
                textAlign={'center'}
              >
                {order.trackingCode} {order.providerStatus}
              </Typography>
            </Box>
          )}
          <Box>
            <OrderTag order={order} status={order.status as EOrderStatus} />
          </Box>
          {order.providerStatusText && (
            <Box pt={1}>
              <Tag color={`success`}>{order.providerStatusText}</Tag>
            </Box>
          )}
          <Typography
            variant="subtitle2"
            mt={1}
            fontSize={11}
            color="text.secondary"
          >
            {dayjs(order.createdAt).format(ONLY_DATE_TIME_FORMAT)}
          </Typography>
        </>
      ),
    },
    {
      title: 'สินค้า',
      dataIndex: 'items',
      key: 'items',
      align: 'left' as const,
      render: (items: IOrderItem[]) => (
        <Box minWidth={75}>
          {items
            ?.map((item: IOrderItem, index: number) => {
              return `${item.productName} x ${item.quantity}`
            })
            .join(', ')}
        </Box>
      ),
    },
    {
      title: 'ราคา',
      dataIndex: 'total',
      key: 'total',
      align: 'center' as const,
      render: (total: string, order: IOrder) => (
        <Grid
          container
          flexDirection={'column'}
          textAlign={'center'}
          minWidth={110}
        >
          <Grid item>
            <Typography variant="h5" color="error.main">
              {total.toLocaleString()}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              fontSize={12}
              variant="subtitle2"
              color="text.secondary"
              sx={{ marginTop: 1 }}
            >
              {!order?.isCod ? 'เก็บเงินปลายทาง' : 'โอนผ่านธนาคาร'}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              fontSize={12}
              variant="subtitle2"
              color="text.secondary"
            >
              {order.items.length} รายการ/{order.quantity} ชิ้น
            </Typography>
          </Grid>
        </Grid>
      ),
    },
  ]

  return (
    <>
      <CircularLoading isLoading={ordersList.isLoading} />
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          lg={12}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" color="text.secondary">
            ประวัติการสั่งซื้อ
          </Typography>
        </Grid>
        <Grid item xs={12} lg={12}>
          <Table
            size={'middle'}
            columns={columns}
            scroll={{
              x: columns.reduce(
                (pre, cur: any) => (cur.width ? cur.width + pre : pre),
                0,
              ),
            }}
            dataSource={ordersList.data?.records?.map(
              (order: IOrder, index: number) => {
                return {
                  ...order,
                  key: index,
                }
              },
            )}
            bordered
            pagination={false}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default OrderHistoryTable
